import { render, staticRenderFns } from "./TextEntryActivity.vue?vue&type=template&id=5bc5669a&"
import script from "./TextEntryActivity.vue?vue&type=script&lang=js&"
export * from "./TextEntryActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports